import React, { useState, useContext } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Box from '@material-ui/core/Box'
import Dialog from '@material-ui/core/Dialog'
import DialogContent from '@material-ui/core/DialogContent'
import Slide from '@material-ui/core/Slide'
import Button from '@material-ui/core/Button'
import DialogActions from '@material-ui/core/DialogActions'
import FormControl from '@material-ui/core/FormControl'
import FormLabel from '@material-ui/core/FormLabel'
import FormGroup from '@material-ui/core/FormGroup'
import Typography from '@material-ui/core/Typography'
import IconButton from '@material-ui/core/IconButton'
import Checkbox from '@material-ui/core/Checkbox'
import Clear from '@material-ui/icons/Clear'
import AdminAPI from 'config/api/AdminAPI'
import Loader from 'components/general/Loader'
import CompanySelect from 'components/admin/CompanySelect'
import BrokerSelect from 'components/admin/BrokerSelect'
import { getCapacity, overAllocationWarning, withPendingAllocations, companyOptionLabel } from 'config/helpers/AllocationCapacity'
import { onError } from 'config/lib/errorLib'
import { NotificationManager } from 'react-notifications'

//import componentStyles from 'assets/theme/views/admin/notifications.js'
import componentStylesDialog from 'assets/theme/components/dialog.js'
import componentStylesForms from 'assets/theme/components/forms.js'
import componentStylesButtons from 'assets/theme/components/button.js'

//const useStyles = makeStyles(componentStyles)
const useStylesDialog = makeStyles(componentStylesDialog)
const useStylesForms = makeStyles(componentStylesForms)
const useStylesButtons = makeStyles(componentStylesButtons)

const Transition = React.forwardRef(function Transition(props, ref) {
  	return <Slide direction='down' ref={ref} {...props} />
})

export default function AllocateLeadModal(props) {
	const classes = { ...useStylesDialog(), ...useStylesForms(), ...useStylesButtons() }
  	//const theme = useTheme()
  	const api = new AdminAPI()

    const [company, setCompany] = useState(null)
    const [brokers, setBrokers] = useState([])
    const [companyDetails, setCompanyDetails] = useState(null)
    const [broker, setBroker] = useState('unassigned')
    const [brokersLoading, setBrokersLoading] = useState(false)
    const [allocating, setAllocating] = useState(false)
    const [progress, setProgress] = useState(0)
    const [errored, setErrored] = useState([])
    const [showAll, setShowAll] = useState(false)
    const [overAllocationAcknowledged, setOverAllocationAcknowledged] = useState(false)
    const [allocatedCount, setAllocatedCount] = useState(0)

    // The bulk selection can span products; only annotate capacity when every
    // selected lead is for the same one.
    const selectedProducts = [...new Set(props.leads.map(lead => lead.product))]
    const bulkProduct = selectedProducts.length === 1 ? selectedProducts[0] : null
    const capacity = company && bulkProduct ? getCapacity(props.capacityMap, company, bulkProduct) : null
    const companyName = (props.companies.find(c => c.companyId === company) || {}).name || (company || '').toUpperCase()
    const overAllocationMessage = overAllocationWarning(companyName, capacity, props.leads.length)

    async function allocateLeads() {
        console.log('company: ', company);
        console.log('broker: ', broker);
        console.log('leads: ', props.leads);
        let selectedBroker = broker === 'unassigned' ? null : broker;
        try {
            setAllocating(true);
            let updatedLeads = [];
            let erroredLeads = []; // Local array to collect errored leads with reasons
            let i = 1;
            for (let lead of props.leads) {
                try {
                    let newLead = await api.allocateLead(company, selectedBroker, lead);
                    console.log('newLead: ', newLead);
                    if (newLead.failure) {
                        NotificationManager.error(newLead.failure);
                        const reason = newLead.failure.includes('already been allocated')
                            ? 'Already allocated to company'
                            : 'Other error';
                        erroredLeads.push({ phone: lead.phone, reason }); // Add to local array with reason
                    } else {
                        updatedLeads.push(newLead);
                        setProgress(i);
                        // keep the remaining count honest across the run
                        setAllocatedCount(updatedLeads.length);
                    }
                } catch (e) {
                    onError(e);
                    NotificationManager.error('Error allocating lead ' + lead.phone);
                    erroredLeads.push({ phone: lead.phone, reason: 'Other error' }); // Add to local array with reason
                }
                i++;
            }
            console.log('new leads: ', updatedLeads);
            console.log('errored: ', erroredLeads);

            setErrored(erroredLeads); // Update state after loop

            // Collect IDs of successfully allocated leads
            const allocatedLeadIds = updatedLeads.map(l => l.leadId);
            if (allocatedLeadIds.length > 0 && props.removeLeads) {
                props.removeLeads(allocatedLeadIds);
            }

            if (erroredLeads.length === 0) {
                props.showSuccessAlert('Leads allocated to ' + company.toUpperCase());
                props.deselectAll();
                props.close();
            } else {
                NotificationManager.warning('Some leads could not be allocated. Please review the errors.');
                // Optionally, clear only the successfully allocated leads from selection
                if (allocatedLeadIds.length > 0 && props.deselectAll) {
                    props.deselectAll();
                }
            }
        } catch (e) {
            onError(e);
            NotificationManager.error('Error allocating leads');
        } finally {
            setAllocating(false);
        }
    }

    async function updateCompany(companyId) {
        console.log('update company: ', companyId)
        setCompany(companyId)
        setBrokersLoading(true)
        setOverAllocationAcknowledged(false)
        try {
            let details = await api.getCompanyDetails(companyId)
            let brokers = details.brokerDiary ? await api.getCompanyBrokers(companyId) : []
            console.log('brokers: ', brokers)

            setBrokers(brokers)
            setCompanyDetails(details)
            setBrokersLoading(false)
        } catch(e) {
            onError(e)
            NotificationManager.error('Error getting company brokers')
        }
	}

	return (
        <Dialog
            open={props.isOpen}
            TransitionComponent={Transition}
            keepMounted
            onClose={() => props.close()}
        >
            <div className={classes.dialogHeader}>
				<Typography
					variant='h5'
					component='h5'
					className={classes.dialogTitle}
				>
					Allocate {props.leads.length} {props.leads.length > 1 ? 'Leads' : 'Lead'}
				</Typography>
				<IconButton onClick={() => props.close()}>
					<Clear />
				</IconButton>
			</div>
            {errored.length > 0 ? (
                <>
                    <Box display='flex' flexDirection='column' alignItems='center'>
                        <p>Error allocating:</p>
                        {errored.map((error, index) => (
                            <p key={index}>{error.phone} ({error.reason})</p>
                        ))}
                    </Box>
                    <DialogActions>
                        <Box width='100%' display='flex' justifyContent='flex-end'>
                            <Button onClick={() => props.close()} color='primary'>
                                Close
                            </Button>
                        </Box>
                    </DialogActions>
                </>
            ) : (
                <>
                    {!allocating ? (
                        <>
                            <DialogContent>
                                <FormGroup>
                                    <FormLabel>Assign to Company</FormLabel>
                                    <FormControl>
                                        <CompanySelect
                                            companies={showAll || !props.filteredCompanies ? props.companies : props.filteredCompanies}
                                            capacityMap={props.capacityMap}
                                            product={bulkProduct}
                                            value={company}
                                            onChange={(companyId) => updateCompany(companyId)}
                                        />
                                    </FormControl>
                                    {props.filteredCompanies && props.filteredCompanies.length !== props.companies.length &&
                                        <Box
                                            component='span'
                                            fontSize='12px'
                                            color='primary.main'
                                            style={{cursor: 'pointer', marginTop: '4px', display: 'inline-block'}}
                                            onClick={() => setShowAll(v => !v)}
                                        >
                                            {showAll ? 'Show active only' : `Show all companies (${props.companies.length})`}
                                        </Box>
                                    }
                                </FormGroup>
                                {!brokersLoading ? (
                                    <>
                                        <FormGroup>
                                            <FormLabel>Assign to Broker</FormLabel>
                                            <FormControl variant='outlined' fullWidth>
                                                <BrokerSelect
                                                    brokers={brokers}
                                                    companyDetails={companyDetails}
                                                    product={bulkProduct}
                                                    value={broker}
                                                    onChange={(brokerId) => setBroker(brokerId)}
                                                />
                                            </FormControl>
                                        </FormGroup>
                                        {overAllocationMessage &&
                                            <Box marginTop='1rem'>
                                                <Box class='warning-text'>⚠ {overAllocationMessage}</Box>
                                                <Box display='flex' alignItems='center'>
                                                    <Checkbox
                                                        color='primary'
                                                        checked={overAllocationAcknowledged}
                                                        onChange={(e) => setOverAllocationAcknowledged(e.target.checked)}
                                                    />
                                                    <FormLabel style={{margin: '0', padding: '0'}}>Allocate anyway</FormLabel>
                                                </Box>
                                            </Box>
                                        }
                                    </>
                                ) : (
                                    <Loader height={12} />
                                )}
                            </DialogContent>
                            <DialogActions>
                                <Box width='100%' display='flex' justifyContent='space-between'>
                                    <Button onClick={() => props.close()} color='primary'>
                                        Close
                                    </Button>
                                    <Box>
                                        <Box display='inline-block' marginRight='0.5rem'>
                                            <Button
                                                color='primary'
                                                variant='contained'
                                                onClick={() => allocateLeads()}
                                                disabled={brokersLoading || !company || (!!overAllocationMessage && !overAllocationAcknowledged)}
                                            >
                                                {overAllocationMessage ? 'Allocate Over Cap' : 'Allocate'}
                                            </Button>
                                        </Box>
                                    </Box>
                                </Box>
                            </DialogActions>
                        </>
                    ) : (
                        <Box display='flex' justifyContent='center' alignItems='center' style={{height: '20vh'}}>
                            <Loader />
                        </Box>
                    )}
                    {allocating && (
                        <Box display='flex' flexDirection='column' justifyContent='center' alignItems='center'>
                            <p>Progress: {progress} / {props.leads.length}</p>
                            {capacity &&
                                <p>{companyOptionLabel(companyName, withPendingAllocations(capacity, allocatedCount))}</p>
                            }
                        </Box>
                    )}
                </>
            )}
        </Dialog>
	)
}